const FRACTION_RE = /(-?\d+)\/(\d+)(?!\d)/g;

/** Renders inline "a/b" fraction notation as a real stacked fraction (numerator, bar,
 * denominator) like on a physical whiteboard, instead of a plain slash. Any surrounding
 * text (equations, words) is left untouched. */
export default function FractionText({ text }) {
  if (!text || typeof text !== "string") return text;

  const parts = [];
  let lastIndex = 0;
  let match;
  FRACTION_RE.lastIndex = 0;
  while ((match = FRACTION_RE.exec(text)) !== null) {
    if (match.index > lastIndex) parts.push({ type: "text", value: text.slice(lastIndex, match.index) });
    parts.push({ type: "fraction", num: match[1], den: match[2] });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) parts.push({ type: "text", value: text.slice(lastIndex) });
  if (parts.length <= 1 && parts[0]?.type === "text") return text;

  return (
    <span className="inline-flex flex-wrap items-center gap-0.5 align-middle">
      {parts.map((p, i) =>
        p.type === "text" ? (
          <span key={i}>{p.value}</span>
        ) : (
          <span key={i} className="inline-flex flex-col items-center leading-none mx-1 align-middle" data-testid="stacked-fraction">
            <span className="px-1 pb-0.5">{p.num}</span>
            <span className="w-full min-w-[1em] border-t-2 border-current" />
            <span className="px-1 pt-0.5">{p.den}</span>
          </span>
        )
      )}
    </span>
  );
}
